import { z } from 'zod';

/**
 * Body de `POST /api/v1/proyectos/:id/supervisores`.
 * Espeja `AssignSupervisorDto` del backend (`usuarioId: number`).
 */
export const asignarSupervisorSchema = z.object({
  usuarioId: z.coerce.number().int().positive('Seleccione un supervisor de la lista.'),
});

/**
 * Query de `GET /api/v1/proyectos/supervisores-disponibles`. Cuando
 * `proyectoId` viene definido, el backend excluye supervisores ya
 * asignados a ese proyecto.
 */
export const filtrosSupervisoresDisponiblesSchema = z.object({
  page: z.coerce.number().int().min(1).optional(),
  limit: z.coerce.number().int().min(1).max(100).optional(),
  search: z.string().trim().optional(),
  proyectoId: z.coerce.number().int().positive().optional(),
});

export type AsignarSupervisorInput = z.infer<typeof asignarSupervisorSchema>;
export type FiltrosSupervisoresDisponiblesInput = z.infer<
  typeof filtrosSupervisoresDisponiblesSchema
>;
